import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '@/auth/AuthProvider';
import { Logo } from '@/components/Logo';

export function StudioShell({ children }: { children: ReactNode }) {
  const { isTeacher, isAdmin, isApprover, profile } = useAuth();
  const link = ({ isActive }: { isActive: boolean }) => `rounded-xl px-3 py-2 font-bold ${isActive ? 'bg-brand-soft text-brand' : 'text-ink-muted hover:bg-surface-2'}`;
  return (
    <div className="min-h-dvh">
      <header className="sticky top-0 z-10 border-b border-line bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-[1500px] flex-wrap items-center gap-2 px-4 py-3">
          <div className="mr-4"><Logo to="/studio" small /></div>
          <span className="tag mr-auto">Кабінет викладача{isApprover ? ' · методист' : ''}</span>
          <NavLink to="/studio" end className={link}>Уроки й тести</NavLink>
          <NavLink to="/studio/media" className={link}>Медіатека</NavLink>
          {(isTeacher || isAdmin) && <NavLink to="/studio/students" className={link}>Мої учні</NavLink>}
          {isAdmin && <NavLink to="/admin" className={link}>Адмін</NavLink>}
          <NavLink to="/parent/children" className={link}>Мої діти</NavLink>
          <span className="hidden text-sm font-semibold text-ink-muted md:inline">{profile?.display_name}</span>
        </div>
      </header>
      <main className="mx-auto w-full max-w-[1500px] px-4 py-6">{children}</main>
    </div>
  );
}
